export const objectIsEmpty = obj => {
    if (Object.keys(obj).length === 0 && obj.constructor === Object) {
        return true;
    }

    return false;
};

export const isOnlyAlphaAndNumericValid = value => {
    const regex = /^[a-zA-Z'’‘-\s]+$/;
    if (!value || regex.test(value) === false) {
        return false;
    }
    return true;
};

export const isOtpValid = value => {
    const regex = /^\d{6}$/gm;
    if (!value || regex.test(value) === false) {
        return false;
    }
    return true;
};

export const isEmailValid = value => {
    const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i;
    if (!value || regex.test(value) === false) {
      return false;
    }
    return true;
  };

export const isErrorExist = (statusCode) => {
    var errorCodes = [
        401,
        400,
        500,
        404,
        403,
        504
    ];

    if(!statusCode){
      return false;
    }
  
    return errorCodes.includes(statusCode);
}

export const isErrorExistForOTP = (statusCode) => {
    var errorCodes = [
        400,
        500,
        404,
        403,
        504,
        503,
        502
    ];

    if(!statusCode){
      return false;
    }
  
    return errorCodes.includes(statusCode);
}

export const addMinutes = (date, minutes) => {
    date.setMinutes(date.getMinutes() + minutes);
    return date;
}